import { TelegramAdapter, telegramWebApp } from './telegram';
import { WebAdapter } from './web';
import type { PlatformAdapter } from './types';

const tg = telegramWebApp();
export const platform: PlatformAdapter = tg ? new TelegramAdapter(tg) : new WebAdapter();
export type { PlatformAdapter } from './types';
